import React, { useState, useRef } from "react";
import {
  TextField,Button
} from "@material-ui/core";
import axios from "axios";


function CertificationNumberSend(props) {
    

    const [tensecondsPassed, setTensecondsPassed] = useState(true);
    const inputRef = useRef(null);
    const sendButtonEnable = props.SelfCertification === true ? false : props.phoneValid && tensecondsPassed && props.JeonMoon1 && props.JeonMoon2 && props.JeonMoon3 && props.JeonMoon4
    console.log(props);
    const classes = props.useStyles();
    const inputEnabled = props.SelfCertification === true ?  false : props.CertificatoinId.length > 0 && props.phoneValid
  
    const ConfmButtonEnabled = props.SelfCertification === true ?  false : inputEnabled && props.CertiInput.length > 5;

    const reqSms = () => {
        props.onChangeCertificationID("");
        return new Promise(function (resolve, reject) {
          let urlJoin = props.url + "/api/specialMember/certification1";

          let sexgb = props.gender;
          if (props.gender === "2")
          {
            sexgb = "0"
          }

          axios
          .post(
            urlJoin,
            {
              strCustName: props.name ,
              strBirthDay: props.birthday,
              strSex: sexgb,
              strNation: props.InOutGb,
              strTelCompany: props.TeleCompanyCode,
              strCellPhoneNo: props.phone,
              strUserID: 'ADMIN'
            }
          )
          .then((response) => {
            console.log(response);
            response.data.startsWith("OK")?resolve(response.data) :reject(response.data);
         })
          .catch((response) => {
            reject(response.data);
          });
        });
      };
      
      const coinfmSms = () => {
        return new Promise(function (resolve, reject) {
          let urlJoin = props.url + "/api/specialMember/certification2";
          axios
            .post(
              urlJoin,
              {
                strSvcTxSeqno: props.CertificatoinId ,
                strCellPhoneNo: props.phone,
                strSmsCertNo: props.CertiInput,
                strNation: props.InOutGb,
              },
              { withCredentials: true }
            )
        .then((response) => {
          console.log(response);
          response.data.startsWith("NO")? reject(response) : resolve(response)
        })
        .catch((response) => {
          reject(response.data);
        });
          
        });
    };
  
    return ( 
    <>
    <Button variant="outlined" 
            disabled={!sendButtonEnable}
    onClick={() => {
       reqSms().then((msg) => {
        
        props.onChangeCertificationID(msg.substring(3, 13));
        setTensecondsPassed(false);
        inputRef.current.focus();
        setTimeout(() => {
          setTensecondsPassed(true);
        }, 10000);
       }, (errMsg) => { 
        
        alert(errMsg); }
               )
    }}>인증번호발송하기</Button>
    <TextField
    className={classes.TextFieldWith70}
    disabled={!inputEnabled}
    inputRef={inputRef}
    fullWidth
    label="인증번호"
    type="text"
    multiline={true}
    variant="filled"
    name="etcDetail"
    defaultValue={props.CertiInput}
    onChange={(e) => {
      e.preventDefault();
      props.onChangeCertiInput(e.target.value);
    }}/>
    <Button variant="outlined"
            disabled={!ConfmButtonEnabled}
            size="large"
            onClick={()=> {
              coinfmSms().then(() => {
                props.onChangeSelfCertification(true);
              }, (errMsg) => {
                props.onChangeSelfCertification(false);
                alert(errMsg.data);
              })
            }}
    >확인</Button>
  </> );
}

export default CertificationNumberSend ;